// extracted by mini-css-extract-plugin
export var auto = "_28-1";
export var spinner = "_28-0";